import { useEffect, useMemo } from "react";
import { useCurrentTaxFilingYear } from "../utils/useCurrentTaxFilingYear";
import {
  createTaxFormSubmissionListRequest,
  getTaxFormSubmissionViewDefaultFilters
} from "../../../query/search/taxForm/queries/filtering";
import { TaxFormSubmissionRequest } from "../../../services/search";
import { useTaxFormSubmissionRowsSummaryQuery } from "../../../query/search/taxForm/queries/useTaxFormSubmissionRowsSummaryQuery";
import { useUserId } from "../../../query/hooks/helpers";
import { usePayrollSettings } from "../../../query/payments/queries";
import { selectorCurrentYearFilingSettingsEnabled } from "../selectors/selectorCurrentYearFilingSettingsEnabled";
import { useOptInTaxFilling } from "../components/ModalOptInTaxFilling";

let isModalOpened = false;

export const useIsTaxFilingDashboardEnabled = () => {
  const currentYear = useCurrentTaxFilingYear();

  const userId = useUserId();

  const defaultFilters = getTaxFormSubmissionViewDefaultFilters();

  const optInCurrentYearFilling = useOptInTaxFilling(currentYear);

  const currentRequest = useMemo((): TaxFormSubmissionRequest => {
    return createTaxFormSubmissionListRequest(currentYear, defaultFilters);
  }, []);

  const queryPayrollSettings = usePayrollSettings(userId);

  const queryTaxFormSubmissionRowsSummary =
    useTaxFormSubmissionRowsSummaryQuery(currentRequest);

  const isLoading =
    !queryPayrollSettings.isFetched ||
    !queryTaxFormSubmissionRowsSummary.isFetched;

  const isFilingEnabled =
    queryPayrollSettings.data &&
    selectorCurrentYearFilingSettingsEnabled(
      queryPayrollSettings.data,
      currentYear
    );

  const isEnabled =
    isFilingEnabled &&
    queryTaxFormSubmissionRowsSummary.data &&
    queryTaxFormSubmissionRowsSummary.data.listSize > 0;

  useEffect(() => {
    if (!isModalOpened && !isLoading && !isFilingEnabled) {
      isModalOpened = true;
      optInCurrentYearFilling();
    }
  }, [isLoading, isFilingEnabled, currentYear]);

  return {
    isLoading,
    isEnabled
  };
};
